import { createApi } from '@reduxjs/toolkit/query/react';
import {baseQuery} from '@store/baseQuery';
import {BaseQueryMeta, BaseQueryResult} from '@reduxjs/toolkit/dist/query/baseQueryTypes';

export interface IStatistic {
    key: string;
    value: number;
    data?: { name: string; unique_products: number }[];
}

export const HomeApi = createApi({
    reducerPath: 'homeApi',
    baseQuery: baseQuery(),
    endpoints: (builder) => ({
        getStatistics: builder.query<IStatistic[], void>({
            query: () => ({ url: '/statistics' }),
        }),
    }),
});

export const { useGetStatisticsQuery } = HomeApi;